import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "../../lib/utils";

export type CardAccent = "coral" | "lilac" | "aqua" | "sun";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Acento na borda de CIMA (cartao de login/modal, "Para fazer hoje"). */
  accent?: CardAccent;
  /** Acento na borda ESQUERDA (cartoes do Painel: canal, "Primeira vez
   * aqui?" — handoff mede .25rem a esquerda, nao no topo). */
  accentLeft?: CardAccent;
  flush?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { className, accent, accentLeft, flush, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        "card",
        flush && "card--flush",
        accent && `card--accent-${accent}`,
        accentLeft && `card--accent-left-${accentLeft}`,
        className,
      )}
      {...rest}
    />
  );
});

export const CardHeader = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  function CardHeader({ className, ...rest }, ref) {
    return <div ref={ref} className={cn("stack", className)} style={{ marginBottom: ".75rem" }} {...rest} />;
  },
);

export const CardTitle = forwardRef<HTMLHeadingElement, HTMLAttributes<HTMLHeadingElement>>(
  function CardTitle({ className, ...rest }, ref) {
    return <h3 ref={ref} className={cn("card__title", className)} {...rest} />;
  },
);

export const CardDescription = forwardRef<HTMLParagraphElement, HTMLAttributes<HTMLParagraphElement>>(
  function CardDescription({ className, ...rest }, ref) {
    return <p ref={ref} className={cn("card__meta", className)} {...rest} />;
  },
);

export const CardContent = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  function CardContent({ className, ...rest }, ref) {
    return <div ref={ref} className={className} {...rest} />;
  },
);

export const CardFooter = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  function CardFooter({ className, ...rest }, ref) {
    return <div ref={ref} className={cn("cluster", className)} style={{ marginTop: ".75rem" }} {...rest} />;
  },
);
